import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ScrollingModule } from '@angular/cdk/scrolling'
import { SearchInputComponent } from './components/search-input/search-input.component'
import { ResultsListComponent } from './components/results-list/results-list.component'
import { ResultItemComponent } from './components/result-item/result-item.component'
import { QuickActionsContainerComponent } from './containers/quick-actions-container/quick-actions-container.component'
import { MatIconModule } from '@angular/material/icon'

@NgModule({
	declarations: [
		QuickActionsContainerComponent,
		SearchInputComponent,
		ResultsListComponent,
		ResultItemComponent,
	],
	imports: [CommonModule, ScrollingModule, MatIconModule],
	exports: [
		QuickActionsContainerComponent,
		SearchInputComponent,
		ResultsListComponent,
		ResultItemComponent,
	],
	providers: [],
})
export class QuickActionsModule {}
